window.axios = require('air-vue-model/axios')
window.moment = require('air-vue-model/moment')
window.moment.localDateTime = (date) => date ? window.moment.utc(date, 'YYYY-MM-DD HH:mm:ss')
    .local().format('DD.MM.YYYY HH:mm:ss') : null
window._ = require('lodash')
